
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Слой_1","data-name":"Слой 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 16.2"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('title',[_v('Vector-3')]),_c('path',{staticClass:"cls-1",attrs:{"d":"M9.66.39,12,4.93l5.33.73a.69.69,0,0,1,.41,1.19l-3.86,3.54.91,5a.73.73,0,0,1-1.07.74L9,13.76,4.24,16.12a.73.73,0,0,1-1.07-.74l.91-5L.22,6.85A.69.69,0,0,1,.63,5.66L6,4.93,8.34.39A.75.75,0,0,1,9.66.39Z","transform":"translate(0 0)"}})])
          )
        }
      }
    